export const LIVELO_TRAVEL = {
  Header: 'T&C – RAPPI – Acúmulo de pontos LIVELO',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por meio desta oferta, divulgados os Termos e Condições da <strong>"RAPPI – Acúmulo de pontos LIVELO"</strong>,
        por meio da qual usuários, podem acumular pontos LIVELO ao comprar <strong>HOTEIS</strong> através do aplicativo
        Rappi na loja Livelo.`,
        '"Usuário" para fins deste T&C significa a pessoa física inscrita na plataforma Rappi.',
      ]
    },
    {
      Title: 'REGRAS PRINCIPAIS DA PROMOÇÃO:',
      Paragraphs: [
        '- Ganhe pontos comprando através do aplicativo Rappi na loja Livelo',
        '- Acúmulo de R$ 1 = 3 Pontos Livelo.',
        '- Os Pontos acumulados terão validade de 24 meses a partir da data de crédito na Conta Livelo.',
        `- Os Pontos Livelo serão creditados em até 30 (trinta) dias contados da utilização do produto pelo
        cliente (checkout em hotel, passagens já utilizadas, passeios utilizados, entre outros), pelo cliente,
        do produto adquirido no Rappi, desde que o número do CPF informado seja válido. A Rappi e a Livelo não
        se responsabilizam pela informação incorreta, pelo consumidor, do número de CPF.`,
        `- A quantidade de Pontos Livelo será calculada sobre o montante do valor dos produtos adquiridos no
        aplicativo Rappi. - O crédito de Pontos Livelo será realizado no mesmo número CPF daquele realizador da
        compra (informado no cadastro do parceiro e/ou fluxo de compra), não sendo permitida a doação dos Pontos a terceiros.`,
        `- A oferta é válida apenas para compras realizadas por meio da loja Livelo no botão Rappi Travel, no
        aplicativo Rappi. - Ofertas não acumulativas com outras ofertas/promoções e válidas apenas enquanto durarem os estoques.`,
        '- Promoção válida das 0h00 do dia <strong>22/06/21 até 23:59 do dia 22/07/21</strong>',
      ]
    },
    {
      Title: 'CONDIÇÕES GERAIS DA PROMOÇÃO:',
      Paragraphs: [
        `Promoção válida até a data e hora estipuladas ou enquanto durarem os estoques. Reservamo-nos o direito de cancelar
        qualquer transação que, devido às suas características, viole as condições de elegibilidade a esta promoção.`,
        'Esta promoção é pessoal e intransferível, será aplicada apenas aos usuários que aplicarem o cupom. ',
        `A Rappi se reserva o direito de encerrar esta promoção a qualquer momento em caso de fraude ou desviação da
        doação para terceiros.`,
        `O usuário reconhece e aceita que o fornecedor direto dos produtos é o Parceiro Comercial (estabelecimento),
        uma vez que este é o único que exibe, oferece, promove e comercializa produtos para os usuários/consumidores através
        da Plataforma.`,
        `O Usuário reconhece e aceita que as informações fornecidas e registradas na plataforma virtual Rappi são verdadeiras
        e confiáveis, assumindo total responsabilidade por sua falsidade. As informações fornecidas terão o caráter de uma
        declaração juramentada, os Usuários têm total responsabilidade pela autenticidade e veracidade das mesmas,
        não sendo a Rappi responsável, caso o Usuário incorra na omissão e/ou erro no momento do carregamento dos
        dados solicitados pelo Usuário para obter os benefícios da Promoção. `,
        `A Rappi se reserva o direito de cancelar a promoção, cancelar o código e bloqueando a conta do Usuário
        a qualquer momento, se for determinado que estão ocorrendo fraude ou ação ilícita para obtenção do benefício.`,
        `A Rappi se reserva o direito de modificar as condições ou cancelar esta promoção a qualquer momento e a seu
        critério livre.`,
        `O Rappi não permitirá que o Usuário acesse o cupom quando for verificado que as contas referidas são fictícias
        ou falsas. Usuários que realmente não constituem uma pessoa física identificável por meio de um documento de
        identidade emitido pela autoridade competente.`,
        `A RAPPI reserva-se o direito, a seu exclusivo critério, de modificar, alterar ou atualizar estes Termos e Condições
        a qualquer momento. As modificações serão comunicadas no aplicativo RAPPI e entrarão em vigor imediatamente a partir
        do momento de sua publicação.`,
        `O Rappi não comercializa produtos, pois é apenas uma plataforma tecnológica de intermediação entre terceiros que exibe
        serviços e produtos aos usuários/consumidores que os adquirem.`,
        'Promoção válida na área de cobertura do Rappi para usuários do Rappi no Brasil.',
        'Promoção não acumulável com outras promoções.',
        'São Paulo/SP.',
      ]
    }
  ]
};
